import type { SVGAttributes } from 'react';

import { cnIcon } from './icon.constants.js';

import './icon.css';

export const Icon = ({ className, width = 24, height = 24, children, ...restProps }: SVGAttributes<SVGSVGElement>) => {
    const strWidth = width.toString();
    const strHeight = height.toString();

    return (
        <svg
            className={cnIcon({}, [className])}
            width={`${strWidth}`}
            height={`${strHeight}`}
            viewBox={`0 0 ${strWidth} ${strHeight}`}
            {...restProps}
        >
            {children}
        </svg>
    );
};
